import * as config from './config';
import Location from './assets/svg/location.svg';
import Indicator from './assets/svg/indicatorname.svg';
import MinistryOrSector from './assets/svg/ministrysector.svg';
import Dimension from './assets/svg/dimensions.svg';
import Dataset from './assets/svg/datasetname.svg';
import Collection from './assets/svg/collectionname.svg';
import SaveBookmark from './assets/svg/bookmark-active.svg';
import DoubleArrowDownOutlined from './assets/svg/icon_doubledownarrow.svg';

export const ScreenSize = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
};

export const LanguageMap = {
  en: { englishLabel: 'English', label: 'English', dir: 'ltr', active: true },
  hi: { englishLabel: 'Hindi', label: 'हिंदी', dir: 'ltr', active: false },
  te: { englishLabel: 'Telugu', label: 'తెలుగు', dir: 'ltr', active: false },
  ta: { englishLabel: 'Tamil', label: 'தமிழ்', dir: 'ltr', active: false },
  asm: { englishLabel: 'Assamese', label: 'অসমীয়া', dir: 'ltr', active: false },
  ba: { englishLabel: 'Bengali', label: 'বাংলা', dir: 'ltr', active: false },
  gu: { englishLabel: 'Gujarati', label: 'ગુજરાતી', dir: 'ltr', active: false },
  ka: { englishLabel: 'Kannada', label: 'ಕನ್ನಡ', dir: 'ltr', active: false },
  mal: { englishLabel: 'Malayalam', label: 'മലയാളം', dir: 'ltr', active: false },
  mar: { englishLabel: 'Marathi', label: 'मराठी', dir: 'ltr', active: false },
  ne: { englishLabel: 'Nepali', label: 'नेपाली', dir: 'ltr', active: false },
  od: { englishLabel: 'Odia', label: 'ଓଡ଼ିଆ', dir: 'ltr', active: false },
  pun: { englishLabel: 'Punjabi', label: 'ਪੰਜਾਬੀ', dir: 'ltr', active: false },
  sin: { englishLabel: 'Sindhi', label: 'سنڌي‎', dir: 'ltr', active: false },
  urd: { englishLabel: 'Urdu', label: 'اردو', dir: 'ltr', active: false },
  // bodo: { englishLabel: 'Bodo', label: 'बद', dir: 'ltr', active: false }, NA
  dog: { englishLabel: 'Dogri', label: 'डोगरी', dir: 'ltr', active: false },
  sank: { englishLabel: 'Sanskrit', label: 'संस्कृत', dir: 'ltr', active: false },
  // kas: { englishLabel: 'Kashmiri', label: 'کشمیری', dir: 'ltr', active: false }, NA
  kon: { englishLabel: 'Konkani', label: 'कोंकणी ', dir: 'ltr', active: false },
  mait: { englishLabel: 'Maithili', label: 'मैथिली', dir: 'ltr', active: false },
  // mani: { englishLabel: 'Manipuri', label: 'মণিপুরী', dir: 'ltr', active: false },
  bhoj: { englishLabel: 'Bhojpuri', label: 'भोजपुरी', dir: 'ltr', active: false },
  mizo: { englishLabel: 'Mizo', label: 'Mizo', dir: 'ltr', active: false },
  // sant: { englishLabel: 'Santhali', label: 'ᱥᱟᱱᱛᱞᱤ', dir: 'ltr', active: false } NA,
};

export const KdapLanguageMap = {
  en: { englishLabel: 'English', label: 'English', dir: 'ltr', active: true },
  hi: { englishLabel: 'Hindi', label: 'हिंदी', dir: 'ltr', active: false },
  ka: { englishLabel: 'Kannada', label: 'ಕನ್ನಡ', dir: 'ltr', active: false },
};

export const MegDapLanguageMap = {
  en: { englishLabel: 'English', label: 'English', dir: 'ltr', active: true },
  hi: { englishLabel: 'Hindi', label: 'हिंदी', dir: 'ltr', active: false },
};

export const UserDesignations = [
  { id: 1, title: 'Government' },
  { id: 2, title: 'Student' },
  { id: 3, title: 'Industry' },
  { id: 4, title: 'Journalist' },
  { id: 5, title: 'Civil Societies' },
  { id: 6, title: 'Others' },
];

/* eslint-disable */
export const InputRegex = {
  Password: /^(?=.*\d)(?=.*[!@#$%^&*_~])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
  Name: /^[a-zA-Z0-9\s]*$/,
  UserName: /^[a-zA-Z]{1,}([a-zA-Z]|[. ](?![. ])){0,}$/,
  Email:
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i,
  BookmarkName: /^(?![\s-:_])[\w\s-:]{1,300}$/,
  commonName: /[^\w\s-:]/gi,
};

export const VARIABLE_TYPES = {
  keyIdentifier: 'Key Identifier',
  stringVariable: 'String Variable',
  numericVariable: 'Numeric Variable',
  categoryVariable: 'categorical Variable',
  query: 'q',
};

export const JoyridePages = {
  GlobalJoyride: 'GlobalJoyride',
  Joyride: 'Joyride',
  Home: 'Home',
  Sector: 'Sector',
  Ministry: 'Ministry',
  Dataset: 'DatasetProfile',
  DatasetData: 'DatasetData',
  DatasetVisualization: 'DatasetVisualization',
  Merge: 'Merge',
  Catalogue: 'Catalogue',
  VisualizationCharts: 'VisualizationCharts',
  SuggestDataset: 'SuggestDataset',
  SearchResults: 'SearchResults',
  MergeResult: 'MergeResult',
  MergeResultData: 'MergeResultData',
  MergeResultVisualize: 'MergeResultVisualize',
  UserProfile: 'UserProfile',
};

export const JOYRIDE_PAGE_CONNECTION = {
  datasetprofile: JoyridePages.Dataset,
  datasetdata: JoyridePages.DatasetData,
  datasetvisualization: JoyridePages.DatasetVisualization,
  merge: JoyridePages.Merge,
  mergeprofile: JoyridePages.MergeResult,
  mergedatatable: JoyridePages.MergeResultData,
  mergevisualize: JoyridePages.MergeResultVisualize,
};

const { keyIdentifier, stringVariable, numericVariable, categoryVariable, query } = VARIABLE_TYPES;

export const SymboleIcon = {
  dataset: Dataset,
  indicatorname: Indicator,
  collection: Collection,
  ministry: MinistryOrSector,
  sector: MinistryOrSector,
  location: Location,
  dimensions: Dimension,
  indicator: Indicator,
  saveBookmark: SaveBookmark,
  [keyIdentifier]: Dimension,
  [stringVariable]: Indicator,
  [numericVariable]: Indicator,
  [categoryVariable]: Indicator,
  [query]: Indicator,
  search: Location,
  DoubleArrowDownOutlined: DoubleArrowDownOutlined,
  Datasets: Dataset,
  Indicators: Indicator,
};

export const GridFixedSpan = {
  oneColumn: { xs: 24, sm: 24, xl: 24, md: 24 },
  twoColumn: { xs: 24, sm: 12, xl: 12, md: 12 },
  threeColumn: { xs: 24, sm: 12, xl: 8, md: 8 },
  fourColumn: { xs: 24, sm: 12, xl: 6, md: 6 },
  size: {
    one: { xs: 24, sm: 2, xl: 2, md: 2 },
    two: { xs: 24, sm: 4, xl: 4, md: 4 },
    three: { xs: 24, sm: 6, xl: 6, md: 6 },
    four: { xs: 24, sm: 8, xl: 8, md: 8 },
    five: { xs: 24, sm: 10, xl: 10, md: 10 },
    six: { xs: 24, sm: 12, xl: 12, md: 12 },
    seven: { xs: 24, sm: 14, xl: 14, md: 14 },
    eight: { xs: 24, sm: 16, xl: 16, md: 16 },
    nine: { xs: 24, sm: 18, xl: 18, md: 18 },
    ten: { xs: 24, sm: 20, xl: 20, md: 20 },
    eleven: { xs: 24, sm: 22, xl: 22, md: 22 },
    full: { xs: 24, sm: 24, xl: 24, md: 24 },
  },
};

export const FATLANGUAGES = ['mal', 'ta', 'sant', 'bhoj', 'mizo', 'ka', 'te'];
export const LOCATION_GRANALURITY = { state: 'state', district: 'district', block: 'block' };

export const FREQUENCIES = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly', 'decadal'];
export const MERGE_MODES = { QUICK_MERGE: 'QUICK_MERGE', CUSTOMIZE_FILTER: 'CUSTOMIZE_FILTER' };

export const TYPE_INDICATORS = 'indicators';
export const TYPE_DIMENSIONS = 'dimensions';
export const TYPE_OTHERS = 'others';
export const TYPE_DIMENSION_OTHERS = 'Others';
export const TYPE_TIME = 'time';
export const TYPE_YEAR = 'Year';
export const TYPE_LOCATION = 'location';
export const TYPE_GRANULARITY = 'granularity';
export const COMBINED_FILTERS = 'combined-filters';
export const TYPE_CONDITION = 'condition';
export const TYPE_CONDITION_VISUALIZATION = 'condition-visualization';

export const TYPE_CHART_LOCATION = 'chart-location';
export const TYPE_CHART_TIME = 'chart-time';
export const TYPE_CHART_OTHERS = 'chart-others';

export const TYPE_ALL_DIMENSIONS = 'all-dimensions';
export const TYPE_Z_AXSIS_DIMENSIONS = 'z-axsis-dimensions';
export const TYPE_BUBBLE_NAME = 'bubble-name';
export const TYPE_X_INDICATER = 'x-indicators';
export const TYPE_Y_INDICATER = 'y-indicators';
export const TYPE_BUBBLE_SIZE = 'bubble-size';
export const INDICATER_DIMENSION_I = 'indicator';
export const INDICATER_DIMENSION_D = 'dimension';
export const TYPE_MAP_HEATMAP = 'map-heatmap';
export const TYPE_MAP_BUBBLE = 'map-bubble';
export const TYPE_PIVOT_COLUMNS = 'pivot-columns';
export const TYPE_EXTRAS = 'extras';
export const TYPE_INDICATORS_CHART = `${TYPE_INDICATORS}-chart`;
export const TYPE_CHART_CONDITION = 'chart-condition';

export const TYPE_OPEN_API_INDICATORS = 'open-api-indicators';
export const TYPE_OPEN_API_LOCATION = 'open-api-location';
export const OPEN_API_TYPES = [TYPE_OPEN_API_INDICATORS, TYPE_OPEN_API_LOCATION];

export const VISUALIZE_TYPES = [
  TYPE_ALL_DIMENSIONS,
  TYPE_Z_AXSIS_DIMENSIONS,
  TYPE_BUBBLE_NAME,
  TYPE_X_INDICATER,
  TYPE_Y_INDICATER,
  TYPE_BUBBLE_SIZE,
  TYPE_MAP_HEATMAP,
  TYPE_MAP_BUBBLE,
  TYPE_PIVOT_COLUMNS,
  TYPE_INDICATORS_CHART,
  TYPE_CHART_LOCATION,
  TYPE_CHART_TIME,
  TYPE_CHART_OTHERS,
  TYPE_CHART_CONDITION,
  TYPE_CONDITION_VISUALIZATION,
];

export const VISUALIZE_TYPE_INDICATORS = [
  TYPE_INDICATORS_CHART,
  TYPE_MAP_BUBBLE,
  TYPE_MAP_HEATMAP,
  TYPE_Y_INDICATER,
  TYPE_X_INDICATER,
  TYPE_BUBBLE_SIZE,
  TYPE_INDICATORS_CHART,
];

export const DATA_FILTER_TYPES = [
  TYPE_DIMENSIONS,
  TYPE_INDICATORS,
  TYPE_OTHERS,
  TYPE_TIME,
  TYPE_LOCATION,
  TYPE_GRANULARITY,
  COMBINED_FILTERS,
  TYPE_CONDITION,
];

export const FILTER_TYPES = [...DATA_FILTER_TYPES, ...VISUALIZE_TYPES, ...OPEN_API_TYPES];

export const MEREGE_COLOR_CODES = ['#8AA8F4', '#EBA9BE', '#3b2667'];
export const DATE_FORMAT_MDY = 'MMM DD, YYYY';

export const CHART_TYPE_AUTOSELECT = 'AutoSelect';
export const CHART_TYPE_LINE = 'LineChart';
export const CHART_TYPE_COLUMN = 'ColumnChart';
export const CHART_TYPE_BUBBLE = 'BubbleChart';
export const CHART_TYPE_PIE = 'PieChart';
export const CHART_TYPE_SCATTER = 'ScatterChart';
export const CHART_TYPE_MAPVIEW = 'MapView';
export const CHART_TYPE_PIVOT = 'PivotTable';
export const CHART_TYPE_TREEMAP = 'TreeMap';

export const API_TYPE_DATASET = 'dataset-details';
export const CHART_TYPES = [
  { name: 'AutoSelect', type: CHART_TYPE_AUTOSELECT, icon: 'AutoSelect', viewType: 0 },
  { name: 'LineChart', type: CHART_TYPE_LINE, icon: 'LineChart', viewType: 1, apiType: 'line' },
  { name: 'ColumnChart', type: CHART_TYPE_COLUMN, icon: 'ColumnChart', viewType: 1, apiType: 'bar' },
  { name: 'BubbleChart', type: CHART_TYPE_BUBBLE, icon: 'BubbleChart', viewType: 1, apiType: 'bubble' },
  { name: 'PieChart', type: CHART_TYPE_PIE, icon: 'PieChart', viewType: 1, apiType: 'pie' },
  { name: 'ScatterChart', type: CHART_TYPE_SCATTER, icon: 'ScatterChart', viewType: 1, apiType: 'scatter' },
  { name: 'MapView', type: CHART_TYPE_MAPVIEW, icon: 'MapView', viewType: 2, apiType: API_TYPE_DATASET },
  {
    name: 'PivotTable',
    type: CHART_TYPE_PIVOT,
    icon: 'PivotTable',
    viewType: 3,
    apiType: 'pivot',
  },
  { name: 'TreeMap', type: CHART_TYPE_TREEMAP, icon: 'TreeMap', viewType: 4, apiType: 'tree' },
];

export const FILTER_INPUTS = {
  ShowHideFilter: 'ShowHideFilter',
  OtherDimensionFilter: 'OtherDimensionFilter',
  time: 'time',
};
export const PROCESSING_TYPE = ['oneStarMetadata', 'twoStarMetadata', 'threeStarMetadata', 'fourStarMetadata'];
export const STANDERED_FUNCTIONS = {
  sum: 'Sum',
  count: 'Count',
  avg: 'Average',
  max: 'Max',
  min: 'Min',
  stddev: 'Standard Deviation',
};
export const WEIGHTED_AVG = {
  TotalPopulationWeight: 'Weighted Avg Population',
  LandAreaWeight: 'Weighted Avg Land Area',
  NumberOfHouseholdsWeight: 'Weighted Avg Number Of Households',
  TotalPopulationMaleWeight: 'Weighted Avg Population Male',
  TotalPopulationFemaleWeight: 'Weighted Avg Population Female',
};

export const GRID_MAJOR = 'Major gridlines';
export const GRID_MINOR = 'Minor gridlines';
export const TICK_MARK_MAJOR = 'Major tick marks';
export const TICK_MARK_MINOR = 'Minor tick marks';
export const GRID = 'Gridlines';
export const TICK_MARKS = 'Tick marks';
export const LODARITHIMIC_X = 'Logarithmic X Axis';
export const LODARITHIMIC_Y = 'Logarithmic Y Axis';

export const CHART_GRIDS_AND_LINES = [GRID, TICK_MARKS, LODARITHIMIC_X, LODARITHIMIC_Y];
export const INITIAL_CHART_GRIDS_AND_LINES = [GRID, TICK_MARKS];
export const VIEW_MODE_PREVIEW = 'preview';
export const VIEW_MODE_VIEW = 'view';

export const ACTIVITIES = {
  PAGE_VIEW: 'page_view',
  MAIN_SEARCH: 'main_search',
  STATIC_DOWNLOAD: 'static dataset download',
  DYNAMIC_DOWNLOAD: 'Dynamic Filtered Download',
  SAVE_BOOKMARK: 'Save Bookmark',
  DELETE_BOOKMARK: 'delete Bookmark',
  SUBSCRIBE: 'Subscribe',
  UNSUBSCRIBE: 'Unsubscribe',
  CHANGE_LANGUAGE: 'change language',
  USER_REGISTRATION: 'user registration',
  USER_LOGIN: 'login',
  BOOKMARK_SCHEDULE: 'bookmark schedule',
  VIEW_PROCESSING_REPORT: 'view processing report',
  SUGGEST_DATASET: 'suggest new dataset',
  START_MERGE: 'start merge',
  QUICK_MERGE: 'quick merge',
  CUSTOMIZE_MERGE: 'customize filters and Indicators - Merge',
  ADVANCE_MERGE: 'complete advanced merge',
  SHARE: 'share facebook or share Twitter or copy link',
  CREATE_VISUALIZATION: 'create visualization',
  DOWNLOAD_VISUALIZATION: 'download visualization',
  DOWNLOAD_METADATA: 'download metadata',
  SCREEN_READER: 'screen reader',
  HELP: 'help',
};
export const ID_STATE = 'StateName';
export const ID_DISTRICT = 'DistrictName';
export const ID_STATE_CODE = 'StateCode';
export const ID_DISTRICT_CODE = 'DistrictCode';
export const DEFAULT_MAP = 'India';
export const ID_COUNTRY = 'Country';
export const ID_BLOCK = 'BlockName';

export const CONDITION_WHERE = 'WHERE';
export const CONDITION_AND = 'AND';
export const CONDITION_OR = 'OR';
export const CONDITION = [CONDITION_AND, CONDITION_OR];

export const CONDITION_OPERATERS = [
  {
    key: 'GT',
    text: 'Greater than',
  },
  {
    key: 'LT',
    text: 'Less than',
  },
  {
    key: 'EQ',
    text: 'Equal to',
  },
  {
    key: 'NE',
    text: 'Not equal to',
  },
  {
    key: 'GE',
    text: 'Greater than or equal to',
  },
  {
    key: 'LE',
    text: 'Less than or equal to',
  },
];

export const TYPE_OPERATOR = 'operator';
export const TYPE_COLUMN = 'column';
export const TYPE_VALUE = 'value';
export const RULE_OTHER_THAN = 'other-than';
export const RULE_ONLY = 'only';
export const RULE_RESTRICTED_UPTO = 'restricted-upto';
export const BLUEBROWN = 'bluebrown';
export const MAPBLUE = 'mapblue';

export const DATAINDEX_DIMENSION_VALUE = 'DimensionValue';
export const ANONYMOUS_USER = 'anonymous user';
export const FONT_MODE_INCREASE = 'increase';
export const FONT_MODE_DECREASE = 'decrease';
export const FONT_MODE_NORMAL = 'normal';

export const FONT_SIZES = ['VerySmall', 'Small', 'Normal', 'Big', 'VeryBig'];
export const DEFAULT_FONTSIZE = 'Normal';
export const YES = 'YES';
export const NO = 'NO';
export const StandarisationYes = 'Yes';
export const LOGIN_PROMPT_KEY = 'Login-Prompted';
export const LOGIN_PROMPT_COUNT = 'Login-Prompted-Count';

export const LOGIN_PROMPT_OBJECT = {
  dataset: 'dataset',
  datasetprofile: 'datasetprofile',
  merge: 'merge',
  mergeprofile: 'mergeprofile',
};

export const LOCATION_MODES = {
  Available: 'Available',
  Selected: 'Selected',
};

export const GRANULARITIES = {
  country: 'country',
  village: 'ULB_RLB_Village',
  'sub-district': 'SubDistrict',
};

export const COLLECTION = 'collection';
export const NOT_APPLICABLE = 'Not Applicable';

export const DATASET_NAME_LENGTH = 350;

export const PIVOT_DOWNLOAD_NAME_LENGTH = 160;

export const STANDARDISED_ONLY = 'standardisedOnly';

export const HIDE_HEADER_SEARCH = ['/', '/search', '/catalogue'];

export const getDomainParameters = () => {
  const host = window.location.host;

  const domainMapping = {
    'localhost:3000': {
      headerLogoPath: '/static/assets/images/ndap_logo_final.png',
      footerLogoPath: '/static/assets/images/ndap_logo.png',
      cognitoPoolId: config.REACT_APP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_COGNITO_CLIENT_ID,
      host,
      languages: LanguageMap,
      domain: 'ndap',
    },
    'ndapapi.com': {
      headerLogoPath: '/static/assets/images/ndap_logo_final.png',
      footerLogoPath: '/static/assets/images/ndap_logo.png',
      cognitoPoolId: config.REACT_APP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_COGNITO_CLIENT_ID,
      host,
      languages: LanguageMap,
      domain: 'ndap',
    },
    'www.ndapapi.com': {
      headerLogoPath: '/static/assets/images/ndap_logo_final.png',
      footerLogoPath: '/static/assets/images/ndap_logo.png',
      cognitoPoolId: config.REACT_APP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_COGNITO_CLIENT_ID,
      host,
      languages: LanguageMap,
      domain: 'ndap',
    },
    'ndap.niti.gov.in': {
      headerLogoPath: '/static/assets/images/ndap_logo_final.png',
      footerLogoPath: '/static/assets/images/ndap_logo.png',
      cognitoPoolId: config.REACT_APP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_COGNITO_CLIENT_ID,
      host,
      languages: LanguageMap,
      domain: 'ndap',
    },
    'dbtmission.ndapapi.com': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_DBTDAP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_DBTDAP_COGNITO_CLIENT_ID,
      host,
      languages: LanguageMap,
      domain: 'dbtdap',
    },
    'kdap.ndapapi.com': {
      headerLogoPath: '/static/assets/images/kdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/kdap_footerlogo.png',
      cognitoPoolId: config.REACT_APP_KDAP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_KDAP_COGNITO_CLIENT_ID,
      host,
      languages: KdapLanguageMap,
      domain: 'kadap',
    },
    'kadap.in': {
      headerLogoPath: '/static/assets/images/kdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/kdap_footerlogo.png',
      cognitoPoolId: config.REACT_APP_KDAP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_KDAP_COGNITO_CLIENT_ID,
      host,
      languages: KdapLanguageMap,
      domain: 'kadap',
    },
    'www.kadap.in': {
      headerLogoPath: '/static/assets/images/kdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/kdap_footerlogo.png',
      cognitoPoolId: config.REACT_APP_KDAP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_KDAP_COGNITO_CLIENT_ID,
      host,
      languages: KdapLanguageMap,
      domain: 'kadap',
    },
    'megdap.ndapapi.com': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_MEGDAP_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_MEGDAP_COGNITO_CLIENT_ID,
      host,
      languages: MegDapLanguageMap,
      domain: 'megdap',
    },
    'https://d2uu4yffjh1qg4.cloudfront.net/': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_MEGDAP_PROD_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_MEGDAP_PROD_COGNITO_CLIENT_ID,
      host,
      languages: MegDapLanguageMap,
      domain: 'megdap',
    },
    'd2uu4yffjh1qg4.cloudfront.net': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_MEGDAP_PROD_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_MEGDAP_PROD_COGNITO_CLIENT_ID,
      host,
      languages: MegDapLanguageMap,
      domain: 'megdap',
    },
    'megdap.in': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_MEGDAP_PROD_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_MEGDAP_PROD_COGNITO_CLIENT_ID,
      host,
      languages: MegDapLanguageMap,
      domain: 'megdap',
    },
    'www.megdap.in': {
      headerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      footerLogoPath: '/static/assets/images/megdap_headerlogo.png',
      cognitoPoolId: config.REACT_APP_MEGDAP_PROD_COGNITO_USER_POOL,
      cognitoClientId: config.REACT_APP_MEGDAP_PROD_COGNITO_CLIENT_ID,
      host,
      languages: MegDapLanguageMap,
      domain: 'megdap',
    },
  };

  const defaultDomain = {
    headerLogoPath: '/static/assets/images/ndap_logo_final.png',
    footerLogoPath: '/static/assets/images/ndap_logo.png',
    cognitoPoolId: config.REACT_APP_COGNITO_USER_POOL,
    cognitoClientId: config.REACT_APP_COGNITO_CLIENT_ID,
    host,
    languages: LanguageMap,
    domain: 'ndap',
  };

  return domainMapping[host] || defaultDomain;
};

export const homePageTabs = {
  sectors: 'sectors',
  ministries: 'ministries',
  mostviewed: 'mostviewed',
  recentlyadded: 'recentlyadded',
};

export const CATALOG_DOMAIN_DETAILS = {
  kadap: ['kadap', 'ndap'],
  megdap: ['megdap', 'ndap'],
};

export const STATE_DOMAIN = {
  ndap: 'National',
  kadap: 'Karnataka',
  megdap: 'Meghalaya',
  dbtdap: 'DBT Mission',
};

export const MAP_VIEW_DOMAIN = {
  ndap: 'India',
  kadap: 'Karnataka',
  megdap: 'Meghalaya',
  dbtdap: 'DBT Mission',
};

export const ALL_DOMAINS = {
  ndap: 'ndap',
  kadap: 'kadap',
  megdap: 'megdap',
  dbtdap: 'dbtdap',
};

export const IS_REGISTRATION = {
  ndap: true,
  kadap: true,
  megdap: true,
  dbtdap: false,
};

export const GEO_DATA_DOMAIN = {
  ndap: {
    type: 'FeatureCollection',
    boundTop: '66',
    boundLeft: '38',
    boundBottom: '100',
    boundRight: '7',
  },
  kadap: {
    type: 'FeatureCollection',
    boundTop: '70.08802',
    boundLeft: '17.4408',
    boundBottom: '82.57797',
    boundRight: '12',
  },
  megdap: {
    type: 'FeatureCollection',
    boundTop: '89.81682',
    boundLeft: '26.11752',
    boundBottom: '92.80337',
    boundRight: '25.02952',
  },
};

export const LANG_COUNT = {
  ndap: 21,
  kadap: 3,
};

export const CATALOG_JOYRIDE = {
  ndap: '',
  kadap: '/NDAP',
};

export const STATE_UT = {
  state: 'State/UT',
};

export const ROW_HEIGHT = {
  small: 39,
  medium: 55,
  large: 75,
  sm: 30,
  md: 40,
};

export const FISC_VARIANT = {
  F1: 'FY',
  F2: 'FY',
  F3: 'FY',
  C0: 'CY',
  X1: 'AY',
  C1: 'AGY',
  F4: 'AY',
  E0: 'ESY',
};

export const CALENDAR_YEAR = 'Calendar Year';
export const CALENDAR_MONTH = 'Month';
export const CALENDAR_DAY = 'CalendarDay';
export const CALENDAR_CODE = 'DayCode';
export const CALENDAR_QUARTER = 'Quarter';
export const CALENDAR_WEEK = 'Week';

export const VISUALISATIONS_ORDER_BY = {
  Year: 'YearCode',
  Month: 'MonthCode',
  Quarter: 'QuarterCode',
  Fortnight: 'FortnightCode',
  Week: 'WeekCode',
  CalendarDay: 'DayCode',
};

export const VISUALISATIONS_XAXIS = {
  Year: 'YearCode',
};

export const CATALOG_FILTER = {
  departments: 'departments',
  ministries: 'ministries',
  locationlevel: 'locationlevel',
  search: 'search',
  sectors: 'sectors',
  timefrequency: 'timefrequency',
};

export const DOMAIN = { ...getDomainParameters() };

export const DEFAULT_KEYWORDS =
  'Aam Aadmi Bima Yojana, AgMarkNet,Commodity Wise Price and Arrival Data, Agricultural Census , Annavitran - Distribution of Food Grains, Annual Survey of Industries (ASI), Atal Pension Yojana, AYUSH Infrastructure and Facilities, Basic Statistical Returns of Scheduled Commercial Banks in India, Census 2011, Central Electricity Authority (CEA) Monthly Power Reports, Climate Vulnerability Assessment for Adaptation Planning in India, Coal Directory, Common Service Centre (CSC) Roll-out Status, Comprehensive National Nutrition Survey (CNNS), Crime in India, Data on Chemical Fertilizers, DBIE-Database on Indian Economy, Department of Administrative Reforms and Public Grievances, Digital India Dashboard, Direct Benefit Transfer Data (DBT), Direct Benefit Transfer In Agriculture Mechanization, e-Anudaan, Early Childhood Care and Education (ECCE), Economic Census, Economic Census - 2013, Energy Dashboard, Financial Assistance Provided by NFDB (National Fisheries Development Board), Foreign Direct Investment Statistics, Fourth All India Handloom Census, Goods and Services Tax (GST) Statistics, Handbook of Statistics on Indian Economy  , Handbook of Statistics on Indian States, Health Management Information System , Health Management Information System (HMIS), Indian Public Finance Statistics , Indian Railways Yearbook, Input Survey 2016-17, Integrated Skill Development Scheme (ISDS), Issuing Passports, Land Use Statistics, Livestock Census, Mahatma Gandhi National Rural Employment Guarantee Act, Mahatma Gandhi National Rural Employment Guarantee Act (MGNREGA) , Marine Fisheries Census, Micro Small and Medium Enterprise Dashboard, Minerals Statistics, Monthly Power Reports, National Achievement Survey (NAS), National Family Health Survey (NFHS), National Family Health Survey-5 , National Fisheries Development Board Annual Report, National Judicial Data Grid, National Sample Survey, National Sample Survey , National Sample Survey (NSS), National Water Monitoring Program (NWMP) Water Quality Data, Panchayati Raj Statistics, Parliamentary Statistics, Periodic Labour Force Survey, Population Census 2001, Population Census 2011, Pradhan Mantri Adarsh Gram Yojana (PMAGY), Pradhan Mantri Awas Yojana (Urban) (PMAY), Pradhan Mantri Fasal Bima Yojana, Pradhan Mantri Fasal Bima Yojana (PMFBY), Pradhan Mantri Gram Sadak Yojana (PMGSY), Pradhan Mantri Jan Dhan Yojaya (PMJDY), Pradhan Mantri Kisan Sampada Yojana (PMKSY), Pradhan Mantri Shram Yogi Maandhan (PMSYM), Pradhan Mantri Ujjwala Yojana (PMUY), Prison Statistics, Public Enterprises Survey, Rainfall Statistics, Rashtriya Krishi Vikas Yojana (RKVY), RBI Quarterly Statistics on Deposits and Credit of Scheduled Commercial Banks, RBI-Annual Report, Registered Company Master - Ministry of Corporate Affairs (MCA), Report of Trend and Progress of Banking in India, Report on trend and progress of banking in India, Report on Trend and Progress of Housing in India, Reproductive Child Healthcare report, Reserve Bank of India (RBI) Data Base on Indian Economy, Road Statistics, Rural Health Statistics, Scheduled tribe (ST) Statistical Profile, Scholarship Schemes, School Examination Statistics, Skill Development Dashboard, Socio Economic and Caste Census (SECC), State Finances: A Study of Budgets, State level Power Peak Demand and Peak Met, State Month Requirement Avail of chemical Fertilizers, State Wise Deployment of ATMs, Statistical Tables Relating to Banks, Steel Capacity and Production, Sub-mission on Agricultural Mechanization (SMAM), Sustainable Development Goals (SDG) India Index, Telecom Subscription Data, Textile Data, Tourism Statistics, UIDAI Data, Unified District Information System for Education (UDISE), Update on Indian Port Sector, Water Resources Information System (WRIS)';

export const SEO_META_INFO = () => {
  return {
    home: {
      title: 'Home',
      description: `The ${STATE_DOMAIN[DOMAIN?.domain]} Data and Analytics Platform (${ALL_DOMAINS[
        DOMAIN?.domain
      ]?.toUpperCase()}) facilitates and improves access to Indian government data. Through the platform, data sets from across India's extensive administrative landscape can be accessed. ALL_DOMAINS[DOMAIN.domain] allows users to search, merge, visualize, and download datasets easily.`,
      keywords: DEFAULT_KEYWORDS,
    },
    catalogue: {
      title: 'Catalogue',
      description: `Find all datasets across sectors & ministries hosted on The ${
        STATE_DOMAIN[DOMAIN?.domain]
      } Data and Analytics Platform (${ALL_DOMAINS[DOMAIN?.domain]?.toUpperCase()})`,
      keywords: DEFAULT_KEYWORDS,
    },
  };
};

export const MAX_CAPTCHA_LENGTH = 2000;
